import { useGetLmsActiveNewsQuery, useGetLmsCreateRequestsQuery } from '../../../../api';
import { REQUEST_STATUS } from '../../training-request/utils/requestStatus';

const NEWS_COUNT = 5;

const useLmsDashboardHighlights = ({ canViewRequests = true } = {}) => {
    const { data: newsData, isLoading: isNewsLoading } = useGetLmsActiveNewsQuery({ sortOrder: 'desc', pageNumber: 1, pageSize: NEWS_COUNT }, { refetchOnMountOrArgChange: true });

    const { data: pendingData } = useGetLmsCreateRequestsQuery({ pageNumber: 1, pageSize: 1, filters: [{ column: 'Status', operator: 5, value: String(REQUEST_STATUS.PENDING_APPROVAL) }] }, { refetchOnMountOrArgChange: true, skip: !canViewRequests });

    return { news: newsData?.items || [], isNewsLoading, pendingRequestCount: pendingData?.totalCount || 0 };
};

export default useLmsDashboardHighlights;
